module.exports = __webpack_public_path__ + "static/media/auto-full-width.4d7acbe1.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/industry/auto-full-width.png
// module id = 786
// module chunks = 0